<div class="app-container settings" [class.chat-pinned]="displayMode === 'pinned'">
    <app-desktop-menu *appDesktop></app-desktop-menu>

    <div class="settings app-main">
        <router-outlet></router-outlet>
    </div>

    <!-- Quick Start pill — mobile only, independent of which bottom bar shows -->
    <ng-container *appMobile>
        @if (hasNotDismissedBanner$ | async) {
            <button class="quick-start-pill" (click)="openSetupGuide($event)">
                <img
                    src="assets/img/tablet_menu_quick_start.webp"
                    class="qs-icon"
                    alt="" />
                <span>Quick Start</span>
            </button>
            <!-- Hidden instance provides the popup and handles setupGuideService.open$ on mobile -->
            <app-setup-guide-button
                style="display: none"
                [hasNotDismissedBanner]="hasNotDismissedBanner$ | async"
                [asapFormId$]="asapFormId$">
            </app-setup-guide-button>
        }
    </ng-container>

    <ng-container *ngIf="!(hideMenu$ | async)?.hideMobileMenu">
        <ng-container *appMobile>
            <ng-container *ngIf="showContextualBar$ | async; else mainNav">
                <app-mobile-contextual-bar></app-mobile-contextual-bar>
            </ng-container>
            <ng-template #mainNav>
                <app-mobile-bottom-nav></app-mobile-bottom-nav>
            </ng-template>
        </ng-container>
    </ng-container>

    <!-- Mobile options slide-up panel — shared across all detail pages -->
    <app-mobile-options-panel></app-mobile-options-panel>

    <!-- R.I.S.E. floating trigger button — desktop/tablet pill, hidden on mobile and when pinned -->
    @if(displayMode !== 'pinned'){
        <button
            *featureFlag="'riseAgent'"
            class="rise-fab"
            type="button"
            title="Open R.I.S.E. AI Assistant"
            (click)="openRiseAgent()">
            <span class="rise-fab-inner">
                <app-rise-agent-icon variant="onBlue" [size]="24"></app-rise-agent-icon>
            </span>
            <span class="rise-fab-label">Ask R.I.S.E.</span>
        </button>
    }

    <!-- R.I.S.E. AI sidebar -->
    <app-rise-agent-sidebar
        *featureFlag="'riseAgent'"
        [visible]="riseAgentVisible"
        (visibleChange)="onRiseAgentVisibleChange($event)">
    </app-rise-agent-sidebar>
</div>
